import createReducer from '../utils/createReducer';
import actions from '../actions/help';
import {validateEmail, isPPM} from '../utils/validate';

const initialState = {};

const actionHandlers = {
    [actions.TOGGLE_HELP_MODAL](state, {payload}) {
        let isHelpModalOpen = false;
        let isInEligibleModalOpen = false;
        let isUnlistedSoftware = false;
        if (payload.modalType === 'helpModal') {
            isHelpModalOpen = payload.fieldVal;
        } else {
            isInEligibleModalOpen = payload.fieldVal;
        }
        if (payload.unlistedSoftware) {
            isUnlistedSoftware = true;
        }
        return {
            isHelpModalOpen,
            isInEligibleModalOpen,
            isUnlistedSoftware,
        };
    },

    [actions.HANDLE_ONCHANGE](state, {payload}) {
        switch (payload.id) {
            case 'email': return {
                ...state,
                emailVal: payload.value,
                emailError: (payload.value) ? '' : 'ipmob.create_account.button.text_5'
            };

            case 'firstName': return {
                ...state,
                firstNameVal: payload.value,
                firstNameError: (payload.value) ? '' : 'ipmob.help_page.error_msg_1'
            };

            case 'lastName': return {
                ...state,
                lastNameVal: payload.value,
                lastNameError: (payload.value) ? '' : 'ipmob.help_page.error_msg_2'
            };

            case 'phoneNumber': return {
                ...state,
                phoneNumberVal: payload.value,
                phoneNumberError: (payload.value) ? '' : 'ipmob.help_page.error_msg_3'
            };

            case 'companyName': 
                if(state.isUnlistedSoftware) {
                    return {
                        ...state,
                        companyNameVal: payload.value,
                        companyNameError: (payload.value) ? '' : 'ipmob.input.field.required'
                    };
                } 
                return {
                    ...state,
                    companyNameVal: payload.value
                };
            
            case 'propertyCount': return {
                ...state,
                propertyCountVal: payload.value,
                propertyCountError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            case 'softwareName': return {
                ...state,
                softwareNameVal: payload.value,
                softwareNameError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            case 'helpSubject': return {
                ...state,
                helpSubVal: payload.value,
                helpSubError: (payload.value) ? '' : 'ipmob.help_page.error_msg_4'
            };

            case 'helpMessage': return {
                ...state,
                helpMessageVal: payload.value,
                helpMessageError: (payload.value) ? '' : 'ipmob.help_page.error_msg_4'
            };

            default: return {
                ...state
            };
        }
    },

    // eslint-disable-next-line complexity
    [actions.HANDLE_ONBLUR](state, {payload}) {
        switch (payload.id) {
            case 'email':
                if (payload.value && !validateEmail(payload.value)) {
                    return {
                        ...state,
                        emailError: 'ipmob.create_account.button.text_5'
                    };
                }
                return {
                    ...state,
                    emailError: (payload.value) ? '' : 'ipmob.create_account.button.text_5'
                };

            case 'firstName': return {
                ...state,
                firstNameError: (payload.value) ? '' : 'ipmob.help_page.error_msg_1'
            };

            case 'lastName': return {
                ...state,
                lastNameError: (payload.value) ? '' : 'ipmob.help_page.error_msg_2'
            };

            case 'phoneNumber': return {
                ...state,
                phoneNumberError: (payload.value) ? '' : 'ipmob.help_page.error_msg_3'
            };

            case 'propertyCount': return {
                ...state,
                propertyCountError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            case 'softwareName': return {
                ...state,
                softwareNameError: (payload.value) ? '' : 'ipmob.input.field.required'
            };

            case 'companyName': 
            if (state.isUnlistedSoftware) {
                return {
                    ...state,
                    companyNameError: (payload.value) ? '' : 'ipmob.input.field.required'
                };

            } 
                return {
                    ...state
                };
            
            case 'formPhoneNumber': return {
                ...state,
                formPhoneNumberError: (payload.value) ? '' : 'ipmob.help_page.error_msg_3'
            };

            case 'helpSubject': return {
                ...state,
                helpSubError: (payload.value) ? '' : 'ipmob.help_page.error_msg_4'
            };

            case 'helpMessage': return {
                ...state,
                helpMessageError: (payload.value) ? '' : 'ipmob.help_page.error_msg_4'
            };

            case 'helpFormMessage': return {
                ...state,
                helpFormMessageError: (payload.value) ? '' : 'ipmob.help_page.error_msg_4'
            };
            default: return {
                ...state
            };
        }
    },

    [actions.SUBMIT_HELP_FORM_SUCCESS](state, {payload}) {
        return {
            ...state,
            serviceSuccess: payload.msgKey,
            emailVal: '',
            firstNameVal: '',
            lastNameVal: '',
            phoneNumberVal: '',
            propertyCountVal: '',
            softwareNameVal: '',
            companyCountryCode: '',
            companyNameVal: '',
            helpSubVal: '',
            helpMessageVal: ''
        };
    },

    [actions.SUBMIT_HELP_FORM_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.SHOW_FIELD_ERROR](state, {}) {
        if (!state.emailVal) {
            return {
                ...state,
                emailError: 'ipmob.create_account.button.text_5'
            };
        } else if (!state.firstNameVal) {
            return {
                ...state,
                firstNameError: 'ipmob.help_page.error_msg_1'
            };
        } else if (!state.lastNameVal) {
            return {
                ...state,
                lastNameError: 'ipmob.help_page.error_msg_2'
            };
        } else if (!state.phoneNumberVal) {
            return {
                ...state,
                phoneNumberError: 'ipmob.help_page.error_msg_3'
            };
        } else if(state.isUnlistedSoftware && !state.propertyCountVal) {
            return {
                ...state,
                propertyCountError: 'ipmob.input.field.required'
            };
        } else if(state.isUnlistedSoftware && !state.softwareNameVal) {
            return {
                ...state,
                softwareNameError: 'ipmob.input.field.required'
            };
        } else if(state.isUnlistedSoftware && !state.companyNameVal) {
            return {
                ...state,
                companyNameError: 'ipmob.input.field.required'
            };
        } else if (!state.helpSubVal) {
            return {
                ...state,
                helpSubError: 'ipmob.help_page.error_msg_4'
            };
        } else if (!state.helpMessageVal) {
            return {
                ...state,
                helpMessageError: 'ipmob.help_page.error_msg_4'
            };
        }

        return {
            ...state
        };
    },


    // eslint-disable-next-line complexity
    [actions.PREPOPULATE_INELIGIBLE_VALUES](state, {payload}) {
        let emailVal;
        let firstNameVal;
        let lastNameVal;
        let companyCountryCodeVal;
        let companyNameVal;
        let countryName;
        let vatChoice;
        let propertyCountVal;

        let {basicInformation, companyLocation, vatInformation, app, userInfoDetails, propertyCount} = payload.preState;

        if (isPPM(app.userType) || !('vatMetadata' in vatInformation)) {
            const {companyCountryCode, user, ipm} = userInfoDetails.userInfoMetadata;

            countryName = companyCountryCode || '';
            emailVal = user.emailAddress || '';
            firstNameVal = user.firstName || '';
            lastNameVal = user.lastName || '';
            companyNameVal = user.companyName || '';
            companyCountryCodeVal = companyCountryCode || '';
            propertyCountVal = (propertyCount.listingMetadata)
                ? (propertyCount.listingMetadata.liveListingCount + propertyCount.numberOfProperty)
                : ipm.propertyCount || '';
        } else {
            const {email, firstName, lastName} = basicInformation;
            emailVal = email || vatInformation.vatMetadata.userInformation.user.emailAddress || '';
            firstNameVal = firstName || vatInformation.vatMetadata.userInformation.user.firstName || '';
            lastNameVal = lastName || vatInformation.vatMetadata.userInformation.user.lastName || '';
            companyCountryCodeVal = companyLocation.companyCountryCode || vatInformation.vatMetadata.companyCountryInfo.companyCountryCode || '';
            companyNameVal = companyLocation.companyName || vatInformation.vatMetadata.userInformation.user.companyName || '';
            
            if (app.ineligibilityFormStatus === 'INVALID_VAT_NUMBER') {
                countryName = vatInformation.vatMetadata.companyCountryInfo.countryName || '';
                vatChoice = 'yes';
                propertyCountVal = vatInformation.vatMetadata.userInformation.ipm.propertyCount || '';
            } else {
                countryName = companyLocation.companyCountryInfo.countryName || '';
                propertyCountVal = propertyCount.numberOfProperty || 0;
                vatChoice = companyLocation.vatChoice || '';
            }
        }
        if (state.isInEligibleModalOpen) {
            return {
                ...state,
                emailVal,
                firstNameVal,
                lastNameVal,
                companyNameVal,
                companyCountryCode: companyCountryCodeVal,
                businessType: companyLocation.businessType || '',
                helpSubVal: 'SSO Help Request',
                countryName,
                vatChoice,
                propertyCountVal
            };
        }
        return {
            ...state
        };
    }
};

export default createReducer(actionHandlers, initialState);
